import React from 'react'

const Three = () => {
  return (
      <div>
    <small><i className="fa fa-star r-color" aria-hidden="true"></i><i className="fa fa-star r-color" aria-hidden="true"></i><i className="fa fa-star r-color" aria-hidden="true"></i></small>
    </div>
  )
}

export default Three;